import React from "react";
import FormProductCategory from "../components/FormProductCategory";
import { ACTION } from "../const";

const Create = () => {
  return <FormProductCategory action={ACTION.CREATE} />;
};

export default Create;
